/** Recursively trim leading/trailing whitespace from string values in request payloads. */
export function trimStringsDeep(value: unknown): unknown {
  if (value === null || value === undefined) {
    return value;
  }
  if (typeof value === 'string') {
    return value.trim();
  }
  if (Array.isArray(value)) {
    return value.map((item) => trimStringsDeep(item));
  }
  if (typeof value === 'object') {
    const output: Record<string, unknown> = {};
    for (const [key, nested] of Object.entries(value)) {
      output[key] = trimStringsDeep(nested);
    }
    return output;
  }
  return value;
}
